import React from 'react';
import {
    Avatar,
    Box,
    Button,
    Card,
    CircularProgress,
    Input,
    Typography,
    useTheme,
} from "@mui/material";
import {
    BusinessRounded,
    CameraAltRounded,
} from "@mui/icons-material";

const _CorporateLogoCard = ({
    imageUrl,
    inCorporate,
    corporateId,
    uploadingLogo,
    onSelectImage,
}) => {
    const theme = useTheme();

    return (
        <Card
            elevation={0}
            sx={{
                p: 3,
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                textAlign: 'center',
                boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
            }}
        >
            <Box sx={{ position: 'relative', display: 'inline-block', my: 2 }}>
                <Avatar
                    src={imageUrl}
                    alt={inCorporate?.Name || "Corporate Logo"}
                    sx={{
                        width: 130,
                        height: 130,
                        mx: 'auto',
                        border: '4px solid',
                        borderColor: 'primary.light',
                        boxShadow: '0 8px 24px rgba(45, 107, 226, 0.25)',
                        bgcolor: 'primary.50',
                        color: 'primary.main',
                    }}
                >
                    <BusinessRounded sx={{ fontSize: 70 }} />
                </Avatar>

                {uploadingLogo && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            borderRadius: '50%',
                            bgcolor: 'rgba(0,0,0,0.5)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CircularProgress size={32} sx={{ color: '#fff' }} />
                    </Box>
                )}
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 800, mb: 0.5 }}>
                {inCorporate?.Name || "نام سازمان"}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2.5 }}>
                شناسه سازمان: #{corporateId}
            </Typography>

            <label htmlFor="raised-button-file">
                <Input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="raised-button-file"
                    onChange={onSelectImage}
                    type="file"
                />
                <Button
                    variant="outlined"
                    component="span"
                    startIcon={<CameraAltRounded />}
                    sx={{ borderRadius: 2.5, fontWeight: 700, mb: 2 }}
                >
                    بارگذاری لوگوی جدید
                </Button>
            </label>

            <Box
                sx={{
                    p: 1.5,
                    borderRadius: 2.5,
                    bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
                    border: '1px solid',
                    borderColor: 'divider',
                    textAlign: 'right',
                }}
            >
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.8 }}>
                    • فرمت‌های مجاز: PNG, JPG<br />
                    • جهت نمایش بهینه در اپلیکیشن پرسنل، لوگوی بدون پس‌زمینه (Transparent) پیشنهاد می‌شود.
                </Typography>
            </Box>
        </Card>
    );
};

export default _CorporateLogoCard;
